
// 平台
const PLATFORM = {
    NIUNIU: 'niuniu',
    MOOMOO: 'moomoo'
};

// 支持语言
const SUPPORT_LANG_LIST = [0, 1, 2, 5];

// 社区地址基础链接
// 社区地址: LINK + '/' + studio_feed_id
const COMMUNITY_BASE_LINK = {
    [PLATFORM.NIUNIU]: 'https://q.futunn.com/feed',
    [PLATFORM.MOOMOO]: 'https://www.moomoo.com/community/feed',
};
// 获取社区地址
function getCommunityLink({ platform, studioFeedId }) {
    const baseLink = COMMUNITY_BASE_LINK[platform];
    return `${baseLink}/${studioFeedId}`;
}
// 直播地址基础链接
// 直播间地址: LINK + '/' + studio_id
const LIVE_BASE_LINK = {
    [PLATFORM.NIUNIU]: 'https://live.futunn.com/live',
    [PLATFORM.MOOMOO]: 'https://live.moomoo.com/live',
};
// 获取直播地址
function getLiveLink({ platform, studioId }) {
    const baseLink = LIVE_BASE_LINK[platform];
    return `${baseLink}/${studioId}`;
}

// 直播状态
const LIVE_STATUS = {
    UNSUBSCRIBED: 1, // 预约。 直播未开始，自己未预约，未到预播时间
    SUBSCRIBED: 2, // 已预约。 直播未开始，自己已预约，未到预播时间
    WAITING_START: 3, // 等待开始。直播未开始，与自己是否预约无关，已到预播时间
    ON_LIVING: 4, // 去围观。直播已开始，与自己是否预约无关，与预播时间无关
    ENDED_WITHOUT_RECORDING: 5, // 已结束。直播已结束无录播，与自己是否预约无关，与预播时间无关
    ENDED_WITH_RECORDING: 6, // 去回看。直播已结束有录播，与自己是否预约无关，与预播时间无关
    NOT_AVAILABLE: 7, // 已过期。自己未预约，直播没有在预告时间内开始
};

export {
    PLATFORM,
    LIVE_STATUS,
    getLiveLink,
    getCommunityLink,
    SUPPORT_LANG_LIST
};
